import { render, staticRenderFns } from "./customer_page.vue?vue&type=template&id=6bde8e1a"
import script from "./customer_page.vue?vue&type=script&lang=js"
export * from "./customer_page.vue?vue&type=script&lang=js"
import style0 from "./customer_page.vue?vue&type=style&index=0&id=6bde8e1a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports